export const clients = {
  en: [
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-gray.svg',
      alt: 'Samsung',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/verivox-gmbh.svg',
      alt: 'Verivox',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/tui.svg',
      alt: 'TUI',
    },
  ],
  us: [
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-gray.svg',
      alt: 'Samsung',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/asset-book-gray.svg',
      alt: 'Asset Book',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/tiger-connect-gray.svg',
      alt: 'Tiger Connect',
    },
  ],
  au: [
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-gray.svg',
      alt: 'Samsung',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/frugl-gray.svg',
      alt: 'Frugl',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/korda-mentha-gray.svg',
      alt: 'KordaMentha',
    },
  ],
};
